import { render, staticRenderFns } from "./ParcoursProfil.vue?vue&type=template&id=754fe27c&"
import script from "./ParcoursProfil.vue?vue&type=script&lang=js&"
export * from "./ParcoursProfil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports